var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 47 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", {
        attrs: {
          width: "46",
          height: "46",
          transform: "translate(0.355469)",
          fill: "white",
        },
      }),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_907_9307",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "47",
            height: "46",
          },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.355469",
              width: "46",
              height: "46",
              rx: "6",
              fill: "#C4C4C4",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0_907_9307)" } }, [
        _c("path", {
          attrs: {
            d: "M46.3555 46.0005L46.3555 0L0.355003 0L0.355003 46.0005L46.3555 46.0005Z",
            fill: "#4DF4FF",
          },
        }),
        _c("path", {
          attrs: {
            d: "M1.16832 -3.26729L24.0006 -25.9889C30.7304 -32.686 41.6412 -32.686 48.3707 -25.9889L71.203 -3.26729C77.9327 3.42979 77.9327 14.2878 71.203 20.985L48.3707 43.7066C41.6412 50.4037 30.7304 50.4037 24.0006 43.7066L1.16832 20.985C-5.56132 14.2878 -5.56132 3.42979 1.16832 -3.26729Z",
            fill: "#38CDFD",
          },
        }),
        _c("path", {
          attrs: {
            d: "M27.471 0.189668C32.2837 -4.59968 40.0867 -4.59968 44.8995 0.189668H44.8996C49.7122 4.97931 49.7122 12.7445 44.8995 17.5339C40.0867 22.3234 32.2838 22.3234 27.471 17.5339C22.6581 12.7445 22.6581 4.97931 27.471 0.189668Z",
            fill: "#4DF4FF",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }